import React, { useState } from 'react';
import Screen from '../../components/layout/Screen';
import ScrollableContainer from '../../components/ScrollableContainer';
import { Link, useNavigate } from 'react-router-dom';
import SwipeToDelete from 'react-swipe-to-delete-ios';
import { useModal } from '../../common/context/ModalProvider';
import TagsSingleScreen from './TagsAddScreen';
import TagsEditScreen from './TagsEditScreen';
import { ICONS } from '../../common/icons/icons';
import TagsAddScreen from './TagsAddScreen';
import Animated from '../../components/AnimatedComponent';
import SectionTitle from '../../components/SectionTitle';
import TagsService from '@/common/API/TagsService';
import useForceRefetch from '@/common/hooks/useForceRefetch';
import { useDialog } from '@/common/hooks/useDialog';
import { ListApiInfinite } from '@/components/List';
import { GoTrash } from 'react-icons/go';
import AuthorsEditScreen from '../Authors/AuthorsEditScreen';
import { Button } from '@/components/ui/button';
import Toast from '@/common/Toast';

const TagsListScreen = () => {
  const [search, setSearch] = useState('');
  const { shouldRefetch, forceRefetch } = useForceRefetch();
  const { showConfirmDialog, hideConfirmDialog, openDrawer, closeDrawer } = useDialog();
  const navigate = useNavigate();

  const onDelete = (id: number) => {
    showConfirmDialog({
      title: 'Delete tag',
      description: 'Are you sure you want to delete this tag?',
      buttons: [
        {
          title: 'Confirm',
          onClick: () => {
            TagsService.delete(id).then((res: any) => {
              Toast.success(res?.message);
              forceRefetch();
              hideConfirmDialog();
            });
          },
          color: 'primary',
        },
        {
          title: 'Cancel',
          color: 'neutral',
          variant: 'link',
          closesModal: true,
        },
      ],
    });
  };

  return (
    <Screen
      screenContainerClassName='bg-black'
      screenOptions={{
        header: {
          title: 'Tags',
          backBtnLabel: 'Home',
          backBtnUrl: '/home',
          titleClassName: 'text-white',
          rightContent: (
            <Button
              variant='ghost'
              size='icon'
              onClick={() => {
                navigate('/tags/add');
              }}
            >
              {ICONS.plus}
            </Button>
          ),
        },
      }}
    >
      <ListApiInfinite<any>
        onSearch={setSearch}
        queryKey={['authors', search, shouldRefetch]}
        queryFn={({ pageParam }) =>
          TagsService.all({
            page: pageParam,
            search,
            per_page: 20,
          })
        }
        containerClassName='h-full'
        listClassName='mx-4'
        filterClassName='mx-4'
        renderItem={(item, i) => {
          return (
            <div className='grid grid-cols-5 w-full' key={item.id}>
              <Link to={`/tags/${item.id}`} className='col-span-4 p-4 '>
                <span className='text-xs text-white/40 block mb-1'>Tag name</span>
                {item?.name}
              </Link>
              <div className='col-span-1 p-4 flex items-center justify-center' onClick={() => onDelete(item.id)}>
                <GoTrash />
              </div>
            </div>
          );
        }}
        header={
          <section>
            <div className='mb-1 px-4'>
              <SectionTitle label='Tags' className='text-white' />
              <p className='text-white/50'>Tags help you to group your quotes. Use them wisely.</p>
            </div>
            <div className='w-full overflow-hidden flex items-center justify-center'>
              <div className='min-w-[150vw] flex items-center justify-center'>
                <img src='assets/images/tags_img.png' className='h-[200px] w-auto' alt='' />
              </div>
            </div>
          </section>
        }
      />
    </Screen>
  );
};

export default TagsListScreen;
